// @flow

export const COMPANY_TRIAL_WELCOME_MODAL_TRACKING_KEY =
  'has_seen_company_trial_welcome_modal';
export const COMPANY_TRIAL_ENDED_MODAL_TRACKING_KEY =
  'has_seen_company_trial_ended_modal';
